/**
 * 購入履歴一覧画面のグロッサリIDの型定義
 *
 * IDの先頭5桁（GL00x）は同一ファイル内では同じものを使用し、グロッサリファイル間では一意とする。
 * それ以降の5桁はファイル内でIDが被らないように採番する。
 */
export const HistoryGL = {
  /** *過去180日以内のプランのみ表示 */
  DisplayPeriod: 'GL00700001',
  /** 購入 */
  Contract: 'GL00700002',
  /** 解約 */
  Cancel: 'GL00700003',
  /** 保留中 */
  Hold: 'GL00700004',
  /** 再購入 */
  Purchase: 'GL00700005',
  /** 該当履歴がありません */
  NotFoundAnyHistory: 'GL00700006',
  /** 有効期限切れ (売り切りプランの有効期限切れの際に表示)*/
  Expired: 'GL00700007',
  /** 一部解約 */
  IndividualCancel: 'GL00700008',
  /** 自動更新オフ */
  ManualUpdate: 'GL00700009',
  /** 情報を取得できませんでした */
  OtherError: 'GL00799999'
} as const;
export type HistoryGLKeys = typeof HistoryGL[keyof typeof HistoryGL];
